
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55mm","height":"336","viewBox":"0 0 55 88.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"colorable",attrs:{"d":"M27.528 29.712c-3.488-.004-6.99 1.425-9.656 4.299-5.33 5.748-5.345 15.085-.028 20.848 5.317 5.763 13.953 5.778 19.284.03 5.33-5.748 5.345-15.085.028-20.848-2.658-2.881-6.139-4.324-9.628-4.329zm-.028 4.913a8.586 8.586 0 014.6 1.35l-12.438 13.45c-2.054-3.772-1.579-8.712 1.42-11.945 1.777-1.916 4.092-2.859 6.418-2.855zm7.838 4.82c2.069 3.774 1.585 8.735-1.42 11.975-3.001 3.236-7.563 3.712-11.047 1.474z","fill-rule":"evenodd"}}),_c('g',{staticClass:"fg_background",attrs:{"fill":"#fff","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M13.882 7.605c-1.744-.003-3.494.712-4.827 2.15-2.665 2.873-2.672 7.541-.014 10.422 2.658 2.882 6.975 2.89 9.64.016 2.665-2.874 2.672-7.542.014-10.423-1.329-1.441-3.069-2.162-4.813-2.165zm-.014 2.456a4.292 4.292 0 012.3.676L9.95 17.46c-1.027-1.885-.79-4.355.71-5.971.888-.958 2.045-1.43 3.208-1.428zm3.919 2.41c1.034 1.887.792 4.367-.71 5.987-1.5 1.618-3.782 1.856-5.523.737zM41.146 66.557c-1.744-.003-3.495.712-4.827 2.149-2.665 2.874-2.672 7.542-.014 10.423 2.658 2.881 6.975 2.89 9.64.015 2.664-2.873 2.672-7.542.014-10.423-1.329-1.44-3.069-2.162-4.813-2.164zm-.014 2.456c.795 0 1.593.226 2.3.675l-6.219 6.724c-1.027-1.885-.789-4.355.71-5.971.889-.958 2.046-1.43 3.209-1.428zm3.918 2.41c1.034 1.887.792 4.367-.71 5.987-1.5 1.618-3.78 1.856-5.522.737z"}})])])
          )
        }
      }
    